import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

// REDUX IMPORTS
import { Provider } from 'react-redux';
import Store from './store';
import CatchWrapper from 'CatchWrapper';
import { isString } from 'lodash';

let store = Store();

const originalError = console.error;

console.error = (message, ...args) => {
  if (isString(message)) {
    if (message?.includes('Warning') || message?.includes('[React Intl]')) {
      return;
    }
  }

  originalError(message, ...args);
};

ReactDOM.render(
  <Provider store={store}>
    <CatchWrapper>
      <App />
    </CatchWrapper>
  </Provider>,
  document.getElementById('root')
);
serviceWorker.unregister();
